import { productQuantityOrderedStyles as styles } from "@insite/content-library/Components/ProductQuantityOrdered";
import { commonInputHeight, commonTypoStyles } from "@solveindustrial/Utilities/styleguide";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.labelProps = {
    ...styles.labelProps,
    css: css`
        padding: 0 15px 0 0;
        ${mediaQueriesBP.minMD} {
            padding: 10px 10px 0 0;
        }
    `,
    mergeCss: true,
};

styles.cssOverrides = {
    formField: css`
        ${commonTypoStyles};

        input,
        input:not(.react-datetime-picker__inputGroup__input),
        select:not(.react-datetime-picker__inputGroup__input),
        .mobiusFileUpload {
            ${commonTypoStyles};
            ${commonInputHeight};
        }
    `,
};